export default {
  ASSESSMENT: 1,
  ENFORCEMENT: 2,
  EDUCATION: 3,
};
